var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('div',[_c('box-entries-header-date',{attrs:{"entry-data":_vm.entryData}}),_c('box-entries-header-title',{attrs:{"title":_vm.entryData.title}}),_c('div',{staticClass:"contents",domProps:{"innerHTML":_vm._s(_vm.entryData.content)}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }